module.exports = __webpack_public_path__ + "static/media/logo-intro.e61fc752.png";